/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import Icon from './Icon';

const CheckCircleSolid: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <g transform="translate(-12.000000, -470.000000)">
      <g transform="translate(12.249999, 468.000000)">
        <path d="M7.74998152,17.7499958 C12.0301837,17.7499958 15.499963,14.2802165 15.499963,10.0000143 C15.499963,5.71981211 12.0301837,2.25003278 7.74998152,2.25003278 C3.46977933,2.25003278 0,5.71981211 0,10.0000143 C0,14.2802165 3.46977933,17.7499958 7.74998152,17.7499958 Z M6.14640869,14.1035507 L2.89641643,10.8535584 C2.70119595,10.6583074 2.70119595,10.3416883 2.89641643,10.1464373 L3.60353755,9.4393467 C3.79878855,9.2440957 4.11540767,9.2440957 4.31065867,9.4393467 L6.4999845,11.628703 L11.1893044,6.93938317 C11.3845859,6.74410166 11.701205,6.74410166 11.8964255,6.93938317 L12.6035466,7.64647377 C12.7987671,7.84172477 12.7987671,8.15834389 12.6035466,8.35359489 L6.85356032,14.1035812 C6.6582788,14.2988017 6.3416902,14.2988017 6.14640869,14.1035507 Z" />
      </g>
    </g>
  </Icon>
);

export default CheckCircleSolid;
